var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.0022C17.5228 22.0022 22 17.525 22 12.0022C22 6.47935 17.5228 2.0022 12 2.0022C6.47715 2.0022 2 6.47935 2 12.0022C2 17.525 6.47715 22.0022 12 22.0022ZM11 6.0022V14.0022H13V6.0022H11ZM11 16.0022V18.0022H13V16.0022H11Z",
    fill: "#D32F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.4081e7f55c02cad5736c1b9abac76a31.svg";
export { ForwardRef as ReactComponent };